'use strict';

angular.module('app').directive('twoDates', function($window) {
  return {
    restrict: 'A',
    link: function(scope, elem, attr) {
      $(elem).on('click', function() {
        if ($('#pricing').length) {
          var fromDate = $('#js-sidebar-from').val(),
            toDate = $('#js-sidebar-to').val();

          if (fromDate && toDate || !fromDate && !toDate) {
            $('html,body').animate({
              scrollTop: $('#pricing').offset().top - 60
            }, 500);

            return true;
          }

          if (!fromDate && toDate) {
            $('#js-sidebar-from').datepicker('show');
            return true;
          }

          if (!toDate && fromDate) {
            $('#js-sidebar-to').datepicker('show');
            return true;
          }
        }
      })
    }
  }
})